module.exports = __webpack_public_path__ + "static/JIMMY_2014-004-38f533c42585498b5c50150efe4ec8c1.jpg";